import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

const Index = () => {
    const navigate = useNavigate();
    const hasLoggedOut = useRef(false); // Prevent multiple executions

    useEffect(() => {
        const verifyLoginOut = async () => {
            // Prevent multiple executions
            if (hasLoggedOut.current) {
                return;
            }
            hasLoggedOut.current = true;

            console.log("Logging out...");
            Cookies.remove("admin_id");
            Cookies.remove("admin_company_id");
            
            // Show logout confirmation only once
           // alert("You have been logged out.");
            Swal.fire({
                title: 'Success',
                text: 'You have been logged out.',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            // Navigate to login page
            navigate("/login");
        };

        verifyLoginOut();
    }, []); // Remove navigate from dependencies to prevent re-runs

    return <h2>Admin Logging out...</h2>;
};

export default Index;
